/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embedding_Error_Password_ProtectedInputs */



/**
* | output |
* | --- |
* | "This document is password-protected and cannot be read. Remove the password at the source, or upload it again without one." |
*
* @param {Embedding_Error_Password_ProtectedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const embedding_error_password_protected = /** @type {((inputs?: Embedding_Error_Password_ProtectedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embedding_Error_Password_ProtectedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Dokument ist passwortgeschützt und kann nicht gelesen werden. Entfernen Sie das Passwort an der Quelle oder laden Sie es ohne Passwort erneut hoch.")
	return /** @type {LocalizedString} */ ("This document is password-protected and cannot be read. Remove the password at the source, or upload it again without one.")
});